export default __webpack_public_path__ + "static/media/pro_2.f8b38491.png";